import { isPeerupClient } from '@peerup/utils'

export const checkClient = () => {
  if (isPeerupClient) {
    return true
  }
  console.warn('当前环境不是客户端')
  return false
}
/**
 * 封装与客户端交互的工具方法
 */
export const bridge = {
  isPeerupClient,
  /**
   * 判断是否在客户端小窗中
   * 临时处理，后续优化
   */
  isInSubWindow: () => {
    if (!checkClient()) return false
    if (!window.electronAPI?.isChildWindow) return false
    return window.electronAPI.isChildWindow
  },
  /**
   * 当自己为客户端小窗时，关闭自己
   * API暂未实现，先用window.close()
   */
  closeSelf: () => {
    if (bridge.isInSubWindow()) {
      window.electronAPI.closeChildSelf()
    }
  },
  /**
   * 打开客户端小窗
   * @param url 小窗的url
   * @param name 小窗的名称(用于关闭小窗)
   * @returns 是否成功打开小窗
   */
  openSubWindow: (url: string, name: string) => {
    if (!checkClient()) return
    if (!window.electronAPI?.openNewWindow) return console.warn('没有找到 openNewWindow 方法, 请升级客户端')
    const close = () => {
      bridge.closeSubWindow(name)
      window.removeEventListener('focus', close)
    }
    window.addEventListener('focus', close)
    window.electronAPI.openNewWindow(url, name)
    return true
  },
  /**
   * 关闭客户端小窗
   * @param name 小窗的名称
   */
  closeSubWindow: (name: string) => {
    if (!checkClient()) return
    if (!window.electronAPI?.closeWindow) return console.warn('没有找到 closeWindow 方法, 请升级客户端')
    // @ts-expect-error 参数缺失
    return window.electronAPI?.closeWindow(name)
  },
  /**
   * 运行appblock
   * @param val 运行appblock的参数
   * @returns 运行appblock的返回值
   */
  runAppBlock: (val: string) => {
    if (!checkClient()) return
    if (!window.electronAPI?.runAppBlock) return console.warn('没有找到 runAppBlock 方法, 请升级客户端')
    return window.electronAPI.runAppBlock(val)
  },
  /**
   * 停止执行 appblock
   * @param val 停止执行appblock的参数
   * @returns 停止执行appblock的返回值
   */
  closeAppBlock: (options: { runId: string | { appGuid: string; status: number; errorMessage: string }[]; stop: number }) => {
    if (!checkClient()) return
    if (!window.electronAPI?.closeAppBlock) return console.warn('没有找到 closeAppBlock 方法, 请升级客户端')
    return window.electronAPI.closeAppBlock(options)
  },
  /**
   * 通知桌面端有稳定新的增量更新版本出现了
   */
  handleWebUpdate: (val: boolean) => {
    if (!checkClient()) return
    if (!window.electronAPI?.handleWebUpdate) return console.warn('没有找到 handleWebUpdate 方法, 请升级客户端')
    return window.electronAPI.handleWebUpdate(val)
  },
  /**
   * 获取客户端的kernel信息
   * @returns 本地kernel信息
   */
  handleGetLocalKernelInfo: () => {
    if (!checkClient()) return
    if (!window.electronAPI?.getCurrentKernelInfo) return console.warn('没有找到 getCurrentKernelInfo 方法, 请升级客户端')
    return window.electronAPI.getCurrentKernelInfo()
  },
  /**
   * 打开文件系统
   * @param path 文件路径
   */
  openFileSystem: (path: string) => {
    if (!checkClient()) return
    if (!window.electronAPI?.openFileSystem) return console.warn('没有找到 openFileSystem 方法, 请升级客户端')
    return window.electronAPI.openFileSystem(path)
  },
  /**
   * 在系统默认浏览器中打开链接
   * @param url 链接地址
   */
  openExternal: (url: string) => {
    if (!checkClient()) return
    if (!window.electronAPI?.openExternal) return console.warn('没有找到 openExternal 方法, 请升级客户端')
    return window.electronAPI.openExternal(url)
  },
  /**
   * 启动本地kernel
   * @param startKernelParams 启动本地kernel的参数
   * @param requestInfo 启动本地kernel的请求信息
   * @returns 启动本地kernel的返回值
   */
  startKernel: (startKernelParams: any, requestInfo: any) => {
    if (!checkClient()) return
    if (!window.electronAPI.startKernel) return console.warn('没有找到 startKernel 方法, 请升级客户端')
    return window.electronAPI.startKernel(startKernelParams, requestInfo) // 启动本地kernel
  },
  /**
   * 获取文件树
   * @param docId 文档id
   * @returns 文件树
   */
  getDirectoryStructure: (docId: string) => {
    if (!checkClient()) return
    if (!window.electronAPI.getDirectoryStructure) return console.warn('没有找到 getDirectoryStructure 方法, 请升级客户端')
    return window.electronAPI.getDirectoryStructure(docId)
  },
  /**
   * 上传代码包
   * @param codeZipInputWrapper 代码包
   * @param docId 文档id
   * @param requestInfo 请求信息
   * @returns 上传代码包的返回值
   */
  uploadCodePackage: ({ codeZipInputWrapper, docId, requestInfo }: { codeZipInputWrapper: string; docId: string; requestInfo: any }) => {
    if (!checkClient()) return
    if (!window.electronAPI.uploadCodePackage) return console.warn('没有找到 uploadCodePackage 方法, 请升级客户端')
    return window.electronAPI.uploadCodePackage({ codeZipInputWrapper, docId, requestInfo })
  },
}
// if (bridge.isInSubWindow()) {
//   // 监听页面卸载事件， 如果当前页面为客户端小窗，则关闭自己，避免在小窗内打开非预期页面
//   window.addEventListener('beforeunload', () => {
//     bridge.closeSelf()
//   })
// }
